import React from 'react';

import styles from './PromoBanner.module.css';

import type { ReactElement } from 'react';

type Props = {
  onClick: () => void;
};

export const PromoBanner = ({ onClick }: Props): ReactElement => (
  <div className={styles.root}>
    <p onClick={onClick}>$15 OFF your first booking!</p>
  </div>
);
